export default __webpack_public_path__ + "static/footer-ga-logo-6b168d54a461a18fb745b8e6e231b5a4.png";